import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = false

const topBarOpenSlice = createSlice({
  name: 'topBarOpen',
  initialState,
  reducers: {
    toggleFilterTopBar(state, _action: PayloadAction<{ open: boolean }>) {
      return !state
    },
  },
})

export const { toggleFilterTopBar } = topBarOpenSlice.actions
export default topBarOpenSlice.reducer
